import { maybe } from "@saleor/misc";
import { useTableStyles } from "@saleor/remittanceRunner/styles/tableStyles";
import moment from "moment";
import React from "react";

interface RemittanceRunnerTblColDataDateProp {
  dataTitle: string;
  dataValue: string;
  isClickable?: boolean;
  dateFormat?: string;
  centeredText?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const RemittanceRunnerTblColDataDate: React.FC<RemittanceRunnerTblColDataDateProp> = props => {
  const {
    dataTitle,
    dataValue,
    isClickable,
    dateFormat,
    centeredText,
    onClick
  } = props;
  const tblClasses = useTableStyles(props);

  return (
    <div className={tblClasses.dataGroup}>
      <div className={tblClasses.dataTitle}>{dataTitle}</div>
      <div
        className={
          centeredText ? tblClasses.textCenter : tblClasses.dataDisplay
        }
        onClick={isClickable ? onClick : null}
      >
        {maybe(() => dataValue) ? (
          <span className={isClickable ? tblClasses.cursorHand : ""}>
            {moment(dataValue).format(dateFormat)}
          </span>
        ) : (
          <span>-----</span>
        )}
      </div>
    </div>
  );
};

export default RemittanceRunnerTblColDataDate;
